/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

/**
 *
 * Banner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class Banner extends Component {
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12 col-sm-12 imgaboutUsBanner'>
            <a href='javascript:void(0);' className='banner-bg-link'>
              <p className='banner-layout-text-small'>about us</p>
            </a>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Banner;
